import React, { useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import Blogslist from "../../components/Common/Blogs/Blogslist";
import Blogcategory from "../../components/Common/Blogs/BlogCategory";
import RecentBlogs from "../../components/Common/Blogs/RecentBlogs";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from 'react-router-dom';
import { blogByCatIdapi, getblogsapi } from "../../redux/globalslice";
import { MediaQueries } from "../../components/utils";
import user from "../../images/user.png"
import BreadComp from "../../components/Myaccount/BreadComp";
const BlogDetail = () => {
    const dispatch = useDispatch()
    const { isMobile } = MediaQueries()
    const { slug1, slug } = useParams();
    const blogdata = useSelector((state) => state.globalslice.blogdata)
    const blogcatdata = useSelector((state) => state.globalslice.blogcatdata)
    // const id = blogdata?.Categories?.find(ele => ele.url == slug)
    useEffect(() => {
        const input_data = {
            key: "blogId",
            value: slug1
        }
        dispatch(blogByCatIdapi(input_data))
    }, [slug1])

    return (
        <Container fluid className="homepagecontainer" >
               <BreadComp title={slug} title0={"Blog"} />
            <div className="mytractrightside mt-3 mb-2">
                <div className="blogdetail-title">{blogcatdata?.categoryList?.[0].title}</div>
                <div className="blogdeatil-details">
                    <div>
                        <img className="blogdetailuserimg" src={user}></img>
                    </div>
                    <div className="d-flex">
                        <div className="blogdeatilsadmin-name">posted by admin Ourshopee.com</div>
                        <div className="blogdetailsdate">
                                                {(() => {
                                                    const date = new Date(blogcatdata?.categoryList?.[0].display_date);
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                                                    const year = date.getFullYear();
                                                    return `${day}-${month}-${year}`;
                                                })()}
                                            </div>
                    </div>

                </div>

                <img className="blogmain-img" src={blogcatdata?.categoryList?.[0].image}></img>
                <div className="blog-subtitle pt-2 pb-2">
                    <div

                        dangerouslySetInnerHTML={{ __html: blogcatdata?.categoryList?.[0].description }}
                    />
                </div>
            </div>
        </Container>
    )
}
export default BlogDetail;